import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { Tables } from "@msuite/utils/types";
import { ReturnOrderSheetActions } from "./return-order-sheet-actions";

/**
 * Two buttons rather than a menu: with only a view and a download, an ellipsis would hide
 * everything the row can do behind a click that tells the reader nothing.
 */
export function RowActions({ cell }: CellContext<Tables<"files">, "actions">) {
	/** Render */
	return (
		<RowActionsWrapper to={null}>
			<ReturnOrderSheetActions file={cell.row.original} />
		</RowActionsWrapper>
	);
}
